import React, { useCallback, useEffect, useState } from "react";
import { Icon, Checkbox, Select, NumberPicker } from "@alifd/next";
import {
  VirtualDomItemType,
  JsonNodeProps,
  VirtualDomNode,
  LangType,
  VirtualArrayKey,
} from "./type";
import "./index.css";
import { JsonToDomService } from "./service";
import { t } from "../../locale/index";

export default function JsonNode(props: JsonNodeProps) {
  const { node, selectedUuid, onSelect, onChangeArrKey } = props;
  const [collapsed, setCollapsed] = useState(false);
  const [language, setLanguage] = useState<LangType>(LangType.en); //    所属语言
  const [hoverUuid, setHoverUuid] = useState<string>(""); //鼠标经过的uuid

  const jsonToDomService = new JsonToDomService();

  useEffect(() => {
    const lang = window.localStorage.getItem("lang");
    setLanguage((lang as LangType) || LangType.en);
  }, []);

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  if (node) {
    if (
      node.type === VirtualDomNode.object ||
      node.type === VirtualDomNode.array
    ) {
      return (
        <div className="json-node">
          <span>
            {collapsed ? (
              <Icon
                type="add"
                size="xxs"
                onClick={toggleCollapse}
                style={{
                  border: "1px solid #fff",
                  padding: "0 4px",
                  cursor: "pointer",
                  marginLeft: "-22px",
                  color: '#fff'
                }}
              />
            ) : (
              <Icon
                type="minus"
                size="xxs"
                onClick={toggleCollapse}
                style={{
                  border: "1px solid #fff",
                  padding: "0 4px",
                  cursor: "pointer",
                  marginLeft: "-22px",
                  color: '#fff'
                }}
              />
            )}
            {node.type === VirtualDomNode.object ? (
              <span className="object-brackets">{"{"}</span>
            ) : (
              <>
                <span className="array-brackets">{"["}</span>
                <span className="arrayKeyContainer">
                  <Select
                    className="arrayKey-select"
                    value={node.arrayKey}
                    dataSource={[
                      {
                        value: VirtualArrayKey.inputIndex,
                        label: t("jsonToDomSetter.arrayInputKey"),
                      },
                    ]}
                    onChange={(value) => {}}
                  ></Select>
                  {node.arrayKey === VirtualArrayKey.inputIndex ? (
                    <NumberPicker
                      min={0}
                      value={node.arrayValue}
                      onChange={(value) => {
                        onChangeArrKey(node.uuid, value as VirtualArrayKey);
                      }}
                      className="arrayKey-input"
                    ></NumberPicker>
                  ) : null}
                </span>
              </>
            )}
          </span>
          <div className={`json-children ${collapsed ? "collapsed" : ""}`}>
            {node.children?.map((child, index) => {
              return (
                <div key={index} className="json-child">
                  {child.key ? (
                    <>
                      <span className="json-key">"{child.key}"</span>
                      {child?.label ? (
                        <span className="json-label">{`(${child?.label?.[language]})`}</span>
                      ) : null}
                      <span className="json-key">:</span>
                    </>
                  ) : null}
                  <JsonNode
                    node={child}
                    selectedUuid={selectedUuid}
                    onSelect={onSelect}
                    onChangeArrKey={onChangeArrKey}
                  />
                  {index < node.children.length - 1 ? <span>,</span> : null}
                </div>
              );
            })}
          </div>
          <span>
            {node.type === VirtualDomNode.object ? (
              <span className="object-brackets">{"}"}</span>
            ) : (
              <span className="array-brackets">{"]"}</span>
            )}
          </span>
        </div>
      );
    } else {
      return (
        <span
          className="json-node json-leaf"
          onMouseEnter={() => {
            setHoverUuid(node.uuid);
          }}
          onMouseLeave={() => {
            setHoverUuid("");
          }}
        >
          <span
            className={`${jsonToDomService.getClassNameByNode(
              node.type
            )}  json-value`}
            onClick={() => {
              //判断是否选中
              if (selectedUuid === node.uuid) {
                onSelect(node.uuid, false);
              } else {
                onSelect(node.uuid, true);
              }
            }}
          >
            {typeof node.value === "string" ? `"${node.value}"` : node.value}
          </span>
          <Checkbox
            className={
              selectedUuid === node.uuid || hoverUuid === node.uuid
                ? "checkbox-show"
                : "checkbox-hide"
            }
            checked={selectedUuid === node.uuid}
            onChange={(checked) => {
              onSelect(node.uuid, checked);
            }}
          ></Checkbox>
        </span>
      );
    }
  } else {
    return null;
  }
}
